export const navWidth = 87;
export const defaultHeaderHeight = 64;
export const CssRootVariables = {
    mobileViewportHeight: '--fileee-mobile-vh',
    smallGridLineClamp: '--fileee-small-grid-line-clamp'
};
//# sourceMappingURL=constants.js.map